/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CompanyDocumentType } from "./CompanyDocumentType";
import {
  CompanyDocumentTypeFromJSON,
  CompanyDocumentTypeFromJSONTyped,
  CompanyDocumentTypeToJSON,
  CompanyDocumentTypeToJSONTyped,
} from "./CompanyDocumentType";

/**
 *
 * @export
 * @interface CompanyDocumentDataFromHubble
 */
export interface CompanyDocumentDataFromHubble {
  /**
   *
   * @type {string}
   * @memberof CompanyDocumentDataFromHubble
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocumentDataFromHubble
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocumentDataFromHubble
   */
  description?: string | null;
  /**
   *
   * @type {LocalDate}
   * @memberof CompanyDocumentDataFromHubble
   */
  dateReceived?: LocalDate | null;
  /**
   *
   * @type {boolean}
   * @memberof CompanyDocumentDataFromHubble
   */
  isCurrent: boolean;
  /**
   *
   * @type {CompanyDocumentType}
   * @memberof CompanyDocumentDataFromHubble
   */
  documentType: CompanyDocumentType;
  /**
   *
   * @type {string}
   * @memberof CompanyDocumentDataFromHubble
   */
  base64Data: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocumentDataFromHubble
   */
  contentType: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyDocumentDataFromHubble
   */
  isSigned: boolean;
  /**
   *
   * @type {string}
   * @memberof CompanyDocumentDataFromHubble
   */
  customerSpecificPricingAgreementId?: string | null;
}

/**
 * Check if a given object implements the CompanyDocumentDataFromHubble interface.
 */
export function instanceOfCompanyDocumentDataFromHubble(
  value: object,
): value is CompanyDocumentDataFromHubble {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("isCurrent" in value) || value["isCurrent"] === undefined) return false;
  if (!("documentType" in value) || value["documentType"] === undefined)
    return false;
  if (!("base64Data" in value) || value["base64Data"] === undefined)
    return false;
  if (!("contentType" in value) || value["contentType"] === undefined)
    return false;
  if (!("isSigned" in value) || value["isSigned"] === undefined) return false;
  return true;
}

export function CompanyDocumentDataFromHubbleFromJSON(
  json: any,
): CompanyDocumentDataFromHubble {
  return CompanyDocumentDataFromHubbleFromJSONTyped(json, false);
}

export function CompanyDocumentDataFromHubbleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyDocumentDataFromHubble {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    dateReceived:
      json["dateReceived"] == null ? undefined : json["dateReceived"],
    isCurrent: json["isCurrent"],
    documentType: CompanyDocumentTypeFromJSON(json["documentType"]),
    base64Data: json["base64Data"],
    contentType: json["contentType"],
    isSigned: json["isSigned"],
    customerSpecificPricingAgreementId:
      json["customerSpecificPricingAgreementId"] == null
        ? undefined
        : json["customerSpecificPricingAgreementId"],
  };
}

export function CompanyDocumentDataFromHubbleToJSON(
  json: any,
): CompanyDocumentDataFromHubble {
  return CompanyDocumentDataFromHubbleToJSONTyped(json, false);
}

export function CompanyDocumentDataFromHubbleToJSONTyped(
  value?: CompanyDocumentDataFromHubble | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    name: value["name"],
    description: value["description"],
    dateReceived: value["dateReceived"],
    isCurrent: value["isCurrent"],
    documentType: CompanyDocumentTypeToJSON(value["documentType"]),
    base64Data: value["base64Data"],
    contentType: value["contentType"],
    isSigned: value["isSigned"],
    customerSpecificPricingAgreementId:
      value["customerSpecificPricingAgreementId"],
  };
}
